import ScToast from "@/src/components/ui-kit/toast";
import React from "react";
import Toast, { BaseToastProps } from "react-native-toast-message";

export const toastConfig = {
  success: (props: BaseToastProps) => (
    <ScToast
      text1={props.text1 || ""}
      type="success"
      onClose={() => Toast.hide()}
    />
  ),

  error: (props: BaseToastProps) => (
    <ScToast
      text1={props.text1 || ""}
      type="error"
      onClose={() => Toast.hide()}
    />
  ),
};
